module.exports = __webpack_public_path__ + "img/sandton.3d65abfc.jpg";